type SingleOrArray<T> = T | T[]

export interface IKeyConverterDef<Q> {
  field?: keyof Q
  deep?: string
  prefix?: string
  suffix?: string
  custom?: (value: string) => string
}

export type IKeyConverterModel<T, Q> = { [key in keyof T]?: SingleOrArray<IKeyConverterDef<Q>> }

export const createKeyConverter = <T, Q>(params: IKeyConverterModel<T, Q>): IKeyConverterModel<T, Q> => params

export const getKeyConverter = <T, Q>(key: keyof T, converter: IKeyConverterModel<T, Q>): IKeyConverterDef<Q>[] => {
  const temp = converter[key]
  return temp ? (Array.isArray(temp) ? temp : [temp]) : []
}
